import { getEnv } from '@ctct/ctct-helpers';

import { ConversionTrackingHttpClient } from './ConversionTrackingHttpClient';

const CONVERSION_TRACKING_TOKEN = 'c6ee50b1-8cab-40b8-a7a9-ae0b765e8030';

export interface ConversionTrackingPayload {
  souid: string;
  properties?: {
    plan?: string;
    amount?: number;
  };
}

export interface ConversionTrackingResponse {
  message: string;
}

/**
 * API client for tracking conversion events via Rise FOS.
 *
 * Uses dedicated HTTP client WITHOUT 401 redirect interceptor to preserve fail-silent pattern.
 * Conversion tracking failures should never disrupt user experience or redirect users away.
 */
class ConversionTrackingApi {
  private httpClient: ConversionTrackingHttpClient;

  constructor() {
    const baseUrl = `https://www${getEnv()}constantcontact.com`;

    this.httpClient = new ConversionTrackingHttpClient(baseUrl, CONVERSION_TRACKING_TOKEN);
  }

  public async trackConversion(payload: ConversionTrackingPayload) {
    const client = this.httpClient.getClient();

    return client.post<ConversionTrackingResponse>('/api/track-conversion', payload);
  }
}

export const conversionTrackingApi = new ConversionTrackingApi();
